import { PDFDocument } from "pdf-lib";
import {
  getTemplate,
  participantName,
  participantQRCode,
  setDownload,
  drawWrappedText,
  dateNow,
  drawCenteredText,
} from "./utils/utils_certificate";

export async function generateCertificate(participant) {
  try {
    //console.log("participant", participant);
    const myEncode = `${participant.title}|${participant.date}|${participant.now}|${participant.name}|EDUEVENTOS`;

    //console.log("myEncode", myEncode);
    const pdfTemplate = await getTemplate();

    const pdfDoc = await PDFDocument.load(pdfTemplate);

    const page = pdfDoc.getPages()[0];

    const typeCertificate = {
      participation: "DE PARTICIPACIÓN",
      recognition: "DE RECONOCIMIENTO",
      achievement: "DE LOGRO",
      completion: "DE FINALIZACIÓN",
      excellence: "DE EXCELENCIA",
      attendance: "DE ASISTENCIA",
      merit: "DE MÉRITO",
      appreciation: "DE AGRADECIMIENTO",
      honorary: "HONORARIO",
      certification: "DE CERTIFICACIÓN",
    };

    const textStart = "El Ministerio de Educación otorga el presente";
    const textCertificate = "CERTIFICADO";
    const textTypeCertificate =
      typeCertificate[participant.type] || "DE PARTICIPACIÓN";

    //console.log("dimensions", page.getSize());
    //dimensions { width: 793.701, height: 595.276 }

    const leftMargin = 80;
    const rightMargin = 80;
    const fontSize = 16;
    const fontSizeText = 12;
    const lineHeight = 15;

    page.drawText(textStart, {
      x: leftMargin,
      y: 390,
      size: 12,
    });

    await drawCenteredText(page, pdfDoc, textCertificate, 350, 32);
    await drawCenteredText(page, pdfDoc, textTypeCertificate, 320, 32);

    page.drawText("A:", {
      x: 90,
      y: 305,
      size: 10,
    });

    await participantName(page, pdfDoc, String(participant.name), 275, 24);

    await drawWrappedText(
      page,
      pdfDoc,
      `por su participación en ${String(
        participant.title
      )} desarrollado el ${String(participant.date)} de la presente gestión.`,
      leftMargin,
      240,
      fontSizeText,
      16,
      rightMargin
    );

    await dateNow(
      page,
      pdfDoc,
      `La Paz, ${String(participant.now)}`,
      130,
      30,
      10
    );

    // const qrCodeBytes = await participantQRCode(myEncode);
    // const qrImage = await pdfDoc.embedPng(qrCodeBytes);

    // const qrSize = 80;
    // page.drawImage(qrImage, {
    //   x: 682,
    //   y: 32,
    //   width: qrSize,
    //   height: qrSize,
    // });

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    try {
      //const download = await setDownload(participant.participant_id);
      if (1 == 1) {
        // admins pueden generar el certificado sin afectar los datos del participante
        const link = document.createElement("a");
        link.href = url;
        link.download = `certificado_${participant.title}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error ", error);
    }
  } catch (error) {
    console.error("Error", error);
  }
}
